import { AdvertisingConsentModel } from '../../../../../shared/models/view/AdvertisingConsent';
import { BasicPersistenceService } from '../../../../../shared/services/BasicPersistenceService';
import { AppApplicationModel } from '../models/AppApplicationModel';
import { AppFormModel } from "../models/AppFormModel";

export class AppPersistenceService extends BasicPersistenceService<AdvertisngConsentAppDefinition> {
	public getFormModelFromStore(): AppFormModel {
		const applicationModel = this.getApplicationModel();
		return applicationModel.FormModel;
	}

	public setFormModelToStore(formModel: AppFormModel): void {
		const applicationModel = this.getApplicationModel();
		applicationModel.FormModel = formModel;
		this.setApplicationModel(applicationModel);
	}

	/**
	 * Set the advertising consent model to sessionstorage
	 */
	public setAdvertisingConsent(advertisingConsentModel: AdvertisingConsentModel): void {
		T.Utils.Store.set(BasicPersistenceService.DEFAULT_ADVERTISING_CONSENT_SESSION_KEYPREFIX, advertisingConsentModel, T.Utils.Store.VARIABLE);
	}
	/**
	 * need default value because PersistenceService require this signature
	 */
	public getAdvertisingConsent(): AdvertisingConsentModel {
		return AdvertisingConsentModel.createFromObject(T.Utils.Store.get(BasicPersistenceService.DEFAULT_ADVERTISING_CONSENT_SESSION_KEYPREFIX, T.Utils.Store.VARIABLE));
	}

	public getApplicationModel(): AppApplicationModel {
		const dataObject = this.getApplicationObject();
		return AppApplicationModel.createFromObject(dataObject);
	}
}